import { FC } from 'react';
import { IBaseField } from '..';
import { FieldControl } from 'src/UI';
import IssuePassport, { IssuedDataType } from "src/Modules/IssuePassport";

interface IPassportIssueProps extends IBaseField {
	/** Функция вызывается при выборе/очистке значения */
	setValue: ( value?: IssuedDataType | null ) => void;
};

/** Компонента группы поля Кем выдан паспорт */
const PassportIssue: FC<IPassportIssueProps> = ( props ) => {

	const { name, title, isRequired = false, disabled = false, placeholder,
		value, touched = false, error, setValue, onBlur,
	} = props;

	return (
		<FieldControl 
			name={name}
			title={title} 
			isRequired={isRequired}
			isInvalid={!!touched && !!error}
			errorMsg={error}
			notFixedHeight
			onBlur={onBlur}
		>
			<IssuePassport
				allowClear
				style={{ width: "100%" }}
				placeholder={placeholder}
				readonly={disabled}
				value={value}
				isInvalidate={!!touched && !!error}
				onChangeIssue={setValue}
				onBlur={onBlur}
			/>
		</FieldControl>
	);
};

export default PassportIssue;
